import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnlineApplication = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "onlineApplication",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16829",
		"data-name": "Group 16829",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12471",
				"data-name": "Path 12471",
				d: "M20,21H4a2,2,0,0,1-2-2V5A2,2,0,0,1,4,3H20a2,2,0,0,1,2,2V19A2,2,0,0,1,20,21Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12472",
				"data-name": "Path 12472",
				d: "M2,8H22",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12473",
				"data-name": "Path 12473",
				d: "M4.779,5.49a.005.005,0,1,0,.005.005,0,0,0,0,0-.005-.005",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12474",
				"data-name": "Path 12474",
				d: "M7.322,5.49a0,0,0,0,0-.005.005.005.005,0,0,0,.005.005.005.005,0,0,0,0-.01",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12475",
				"data-name": "Path 12475",
				d: "M9.861,5.49a.005.005,0,1,0,.005.005,0,0,0,0,0-.005-.005",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12476",
				"data-name": "Path 12476",
				d: "M8,17.5V15.914a1,1,0,0,1,.293-.707l4-4a1,1,0,0,1,1.414,0l.586.586a1,1,0,0,1,0,1.414l-4,4a1,1,0,0,1-.707.293H8Z",
				transform: "translate(0.707)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12478",
		"data-name": "Path 12478",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgOnlineApplication;
